import type { ErrorInfo } from 'react'
import * as Sentry from '@sentry/react'

import { ResidentAppError } from '../../common/error'

const reportToSentry = Sentry.reactErrorHandler()

/**
 * Reports errors caught by error boundaries to Sentry. ResidentAppErrors are
 * expected API and domain errors that the backend already logs, so they are
 * skipped. Sentry only sends when the user has consented to tracking.
 */
export const reportCaughtError = (error: unknown, errorInfo: ErrorInfo) => {
  // eslint-disable-next-line no-console
  console.error(error, errorInfo.componentStack)

  if (!(error instanceof ResidentAppError)) {
    reportToSentry(error, errorInfo)
  }
}
